import useIsNativeApp from '@hooks/useIsNativeApp'
import { useEffect } from 'react'

/** Registers the service worker and keeps browser updates safe to reload. */
export default function ServiceWorkerRegister() {
  const isNativeApp = useIsNativeApp()

  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return
    if (process.env.NODE_ENV === 'development') {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister()
        }
      })
      return
    }

    const hadController = Boolean(navigator.serviceWorker.controller)
    let isReloading = false
    let reloadTimeoutId: number | null = null

    const reloadForUpdatedWorker = () => {
      if (!hadController || isReloading || isNativeApp) return

      if (!navigator.onLine) {
        window.addEventListener('online', reloadForUpdatedWorker, { once: true })
        return
      }

      if (reloadTimeoutId !== null) return
      reloadTimeoutId = window.setTimeout(() => {
        isReloading = true
        window.location.reload()
      }, 1500)
    }

    navigator.serviceWorker.addEventListener('controllerchange', reloadForUpdatedWorker)

    void navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log(
          'Service Worker registration successful with scope: ',
          registration.scope,
        )
        return registration.update()
      })
      .catch((error) => {
        console.error('Service Worker registration failed: ', error)
      })

    return () => {
      navigator.serviceWorker.removeEventListener(
        'controllerchange',
        reloadForUpdatedWorker,
      )
      window.removeEventListener('online', reloadForUpdatedWorker)
      if (reloadTimeoutId !== null) {
        window.clearTimeout(reloadTimeoutId)
      }
    }
  }, [isNativeApp])

  return null
}
